import { jsx } from 'react/jsx-runtime';

const SvgCommentBlank = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M10 16H4V4h16v12h-5.47L9.5 22h2.61l3.36-4H22V2H2v16h8v-2Z" }) }));

export { SvgCommentBlank as default };
//# sourceMappingURL=CommentBlank.es.js.map
